module.exports = __webpack_public_path__ + "img/zipb&w.830d0375.png";